import React, { useEffect, useState } from "react";
import { Badge, Col, Row } from "antd";
import dayjsTZ from "../../../../utils/dayjs";
import { REQUEST_TYPE_COLORS } from "../utils/statusColors";

const colorVacations = (type) => REQUEST_TYPE_COLORS[type] || "#ea3943";

const getRemainingDays = (objectItem) => {
  const now = dayjsTZ().startOf("day");
  const futureDate =
    objectItem?.requestType === "Dite Personale"
      ? dayjsTZ(objectItem?.requestPeriod[0]).add(1, "days")
      : dayjsTZ(objectItem?.requestPeriod.slice(-1)[0]);
  return futureDate.diff(now, "days");
};

const PlanerOnLeaveSidebar = ({ employeesData = [], leave = [] }) => {
  const [calculated, setCalculated] = useState([]);

  useEffect(() => {
    const onVac = (leave || []).filter((l) => {
      if (l?.requestStatus !== "Aprovuar") return false;
      if (l?.requestType === "Dite Personale") {
        return (
          dayjsTZ(l?.requestPeriod[0]).format("DD/MM/YYYY") ===
          dayjsTZ().format("DD/MM/YYYY")
        );
      }
      return (
        l?.requestPeriod[0] <= dayjsTZ().valueOf() &&
        l?.requestPeriod.slice(-1)[0] > dayjsTZ().valueOf()
      );
    });

    setCalculated(
      onVac
        .map((el) => {
          const emp = employeesData.find((e) => e?.userSub === el?.userSub);
          return {
            ...el,
            employeeFirstName: emp?.employeeFirstName || el?.given_name,
            employeeLastName: emp?.employeeLastName || el?.family_name,
            remainingDays: getRemainingDays(el),
          };
        })
        .sort((a, b) =>
          `${a.employeeFirstName || ""} ${a.employeeLastName || ""}`
            .trim()
            .localeCompare(
              `${b.employeeFirstName || ""} ${b.employeeLastName || ""}`.trim(),
              "sq",
              { sensitivity: "base" }
            )
        )
    );
  }, [leave, employeesData]);

  return (
    <div className="planer-on-leave">
      <div className="list-title">
        {calculated.length} punonjës me pushime
      </div>
      <Row className="emp-days">
        <Col span={14}>Punonjësit</Col>
        <Col className="remain-text" span={10}>
          Ditë
        </Col>
      </Row>
      <div className="emp-days-container">
        {calculated.map((el) => (
          <Row key={el.requestId || el.userSub} align="middle">
            <Col span={14}>
              <Badge
                className="employee-badger"
                color={colorVacations(el?.requestType)}
                text={`${el.employeeFirstName || ""} ${el.employeeLastName || ""}`}
              />
            </Col>
            <Col span={10}>
              <span className="remaining-days">{el.remainingDays}</span>
            </Col>
          </Row>
        ))}
        {!calculated.length ? (
          <div className="planer-empty">Askush nuk është me pushime sot.</div>
        ) : null}
      </div>
    </div>
  );
};

export default PlanerOnLeaveSidebar;
